define('tinymce-base',["tinymce/dom/DomQuery",
        "tinymce/EditorManager",
        "tinymce/dom/EventUtils",
		"tinymce/AddOnManager",
		'tinymce/modern/Theme',
		"tinymce/LegacyInput",
		"tinymce/util/XHR",
		"tinymce/util/JSONRequest",
		"tinymce/util/JSONP",
		"tinymce/util/LocalStorage",

		'tinymce-langs/de',
		'tinymce-ui',
		/*"tinymce/Compat"*/], 
	function(DomQuery, EditorManager, EventUtils, AddOnManager, Theme) {
		if(document.readyState === "complete") // maybe tinymce missed this event
			EventUtils.Event.domLoaded = true;
		
		// see comments in tinymce.post.js
		
		return EditorManager;
});

